import React from "react";
import {IContentBlock} from "../../../ts/data/subject/PostDataHelper";
import HTMLContentView from "./HTMLContentView";


const WysiwygLayoutView = (block: IContentBlock) =>
{
    const mdCols:string = block.narrowLayout ? ' col-md-8 offset-md-2' : '';

    return <>
        {!!block.anchor && <>
            <div id={block.anchor}></div>
        </>}

        <div className="container">
            <div className="row">
                <div className={"col-12 "+ mdCols +" is-content-area"}>
                    {!!block.title && <>
                        <h2 className="block-title">{block.title}</h2>
                    </>}
                    {!!block.introduction && <>
                        <p className="lead block-introduction">{block.introduction}</p>
                    </>}
                    {!!block.content && <>
                        <HTMLContentView
                            className="wysiwyg-content"
                            dangerouslySetInnerHTML={{__html: block.content}}>
                        </HTMLContentView>
                    </>}
                    {!!block.hasCtas && !!(block.ctas ?? []).length && <>

                    </>}
                </div>
            </div>
        </div>
    </>
}
export default WysiwygLayoutView;